import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './store';
import AppRoutes from './routes';
import mixpanel from 'mixpanel-browser';
import './App.scss';
import Hotjar from '@hotjar/browser';
import { persistAttribution, sanitizeCurrentUrlQuery } from './utils/attribution';
import { trackLandingPageView } from './utils/tracking';

const App = () => {

    useEffect(() => {
        const attribution = persistAttribution();
        sanitizeCurrentUrlQuery({
            allowedPathnames: ['/login', '/absite-program-code-request'],
            safeExtraParamKeys: ['next'],
        });
        trackLandingPageView(attribution);
    }, []);

    // Mixpanel 
    mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY);
    // Hotjar
    const siteId = process.env.REACT_APP_HOTJAR_KEY;
    const hotjarVersion = process.env.REACT_APP_HOTJAR_VERSION;
    Hotjar.init(siteId, hotjarVersion);

    return (
        <Provider store={store}>
            <AppRoutes />
        </Provider>
    );
}

export default App;
